import storageService from '../../../../Utils/storageService';

const userDispatch = async (data: any) => {
  switch (data.case) {
    case "ADD":
      if (data?.key) {
        await storageService.setItem(data.key, data.payload);
      }
      break;
    case "GET":
      if (data?.key) {
        return await storageService.getItem(data.key);
      }
      break;
    case "REMOVE":
      if (data?.key) {
        await storageService.removeItem(data.key);
      }
      break;
    case "CLEAR":
      await storageService.clear();
      break;
    default:
      break;
  }
};

export { userDispatch };
